module.exports = __webpack_public_path__ + "static/bettyblocks-54ac1d26dd6656163b8ee1fa168a0776.svg";